export default "__VITE_ASSET__DVovR2YU__"